import http from "../../http-common";

const getUsers = (username) => {
  return http.get(`/api/v1/getUsers?username=${username}`);
};

const getUserInfo = (username) => {
  return http.get(`/api/v1/user/info?username=${username}`);
};

const postNewUser = (body) => {
  return http.post(`/api/v1//users/create`, body);
};

const deleteUser = (username) => {
  return http.delete(`/api/v1//user/delete?username=${username}`);
};

const UsersService = {
  getUsers,
  postNewUser,
  getUserInfo,
  deleteUser,
};

export default UsersService;
